// removed by extract-text-webpack-plugin
module.exports = {"component-wrapper":"styles__component-wrapper___3fxyr","component-title":"styles__component-title___1eHk3","occurences-table":"styles__occurences-table___1tAQ2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportComponents/Tables/SampleSummaryTable/styles.scss
// module id = 7070
// module chunks = 0